import { Link } from 'react-router-dom';

export interface QuotaBannerProps {
  /** Plural noun e.g. "event groups", "events", "stations". */
  resourceLabel: string;
  limit: number;
  used: number;
}

/**
 * Top-of-page banner shown when a primary resource quota has zero room left.
 * Renders only when `limit > 0 && used >= limit` — `limit = 0` is treated as
 * the legacy "no cap configured" sentinel, not as "0 available".
 *
 * Provides the obvious next step: a link to the pricing page so the user can
 * upgrade or buy more without having to first hit the create button and see
 * an error.
 */
export function QuotaBanner({ resourceLabel, limit, used }: QuotaBannerProps) {
  if (!(limit > 0 && used >= limit)) return null;
  return (
    <div
      className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-[var(--color-warn,#F5B400)] bg-[var(--color-warn,#F5B400)]/10 px-4 py-3 text-sm text-[var(--color-xk-lavender,#FFFFFF)]"
      role="status"
    >
      <span>
        You're at <strong>0 available {resourceLabel}</strong>
        <span className="opacity-70"> ({used}/{limit} used)</span>. Upgrade
        your plan to keep creating.
      </span>
      <Link
        to="/pricing"
        className="font-semibold text-[var(--color-xk-accent,#B262F5)] underline"
      >
        See plans →
      </Link>
    </div>
  );
}
